import { render, staticRenderFns } from "./DraftBox.vue?vue&type=template&id=5e349e31&scoped=true"
import script from "./DraftBox.vue?vue&type=script&lang=js"
export * from "./DraftBox.vue?vue&type=script&lang=js"
import style0 from "./DraftBox.vue?vue&type=style&index=0&id=5e349e31&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e349e31",
  null
  
)

export default component.exports